import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

import { BRAND_PANEL_WIDTH } from "../VideoBrandPanel";

// 320 width
export const TINY_MOBILE_CONTAINER_WIDTH = 288;
// 375 width
export const MOBILE_CONTAINER_WIDTH = 343;
// 768 width
export const TABLET_CONTAINER_WIDTH = 720;
// 1440 width
const DESKTOP_CONTAINER_WIDTH = 1295;

export const LARGE_VIDEO_WIDTH = DESKTOP_CONTAINER_WIDTH - BRAND_PANEL_WIDTH;

export const MaxWidthContainer = styled.div`
  margin: 0 auto;
  box-sizing: content-box;
  ${responsiveMediaQueries.mobile} {
    padding: 24px 16px 0 16px;
    width: calc(100% - 32px);
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 0 16px;
    width: calc(100% - 32px);
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    width: calc(100% - 64px);
    padding: 0 32px;
    max-width: ${DESKTOP_CONTAINER_WIDTH}px;
  }
`;
